export const CONTACT_GET_LIST = "/contact";
export const CONTACT_ACTIVE_PROPOSALS = "/contact/active";